const STORAGE_KEY = 'keyflo-scroll-positions';

function readPositions() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function writePositions(positions) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(positions));
  } catch {
    // sessionStorage may be unavailable in some contexts
  }
}

export function saveScrollPosition(pathname, y = window.scrollY) {
  if (!pathname) return;
  const positions = readPositions();
  positions[pathname] = y;
  writePositions(positions);
}

export function getScrollPosition(pathname) {
  if (!pathname) return null;
  const value = readPositions()[pathname];
  return typeof value === 'number' && value >= 0 ? value : null;
}

export function restoreScrollPosition(pathname, { intervalMs = 100, maxWaitMs = 8000 } = {}) {
  const targetY = getScrollPosition(pathname);
  if (targetY == null || targetY <= 0) {
    window.scrollTo(0, 0);
    return () => {};
  }

  const startedAt = Date.now();
  let cancelled = false;

  const tryRestore = () => {
    if (cancelled) return;

    const maxScroll = Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight,
    );

    if (maxScroll >= targetY) {
      window.scrollTo(0, targetY);
      return;
    }

    if (Date.now() - startedAt >= maxWaitMs) {
      window.scrollTo(0, 0);
      return;
    }

    setTimeout(tryRestore, intervalMs);
  };

  tryRestore();
  return () => {
    cancelled = true;
  };
}
